import type React from "react";
import { useEffect } from "react";
import { Platform } from "react-native";

export type FontAwesomeKitLoaderProps = {
  id?: string;
  children?: React.ReactNode;
};

export const FontAwesomeKitLoader = ({
  id,
  children,
}: FontAwesomeKitLoaderProps) => {
  useEffect(() => {
    if (Platform.OS === "web" && id) {
      const script = document.createElement("script");
      script.src = `https://kit.fontawesome.com/${id}.js`;
      script.crossOrigin = "anonymous";
      document.head.appendChild(script);
    }
  }, [id]);

  return children;
};
